import React, { useEffect, useRef, useState } from 'react';
import { Form, Spinner } from 'react-bootstrap';

// Props: value, onChange, onSelect (for autofill), disabled
export default function PostcodeAutocomplete({ required, value, onChange, onSelect, disabled }) {
    const [postcodes, setPostcodes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [query, setQuery] = useState(value || '');
    const [results, setResults] = useState([]);
    const [showResults, setShowResults] = useState(false);
    const inputRef = useRef();
    const resultsRef = useRef();

    useEffect(() => {
        // TODO - use SWR
        fetch('https://raw.githubusercontent.com/matthewproctor/australianpostcodes/master/australian_postcodes.json')
            .then(r => r.json())
            .then(data => {
                setPostcodes(data);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        setQuery(value || '');
    }, [value]);

    function filter(q) {
        if (!q || q.length < 2) {
            setResults([]);
            return;
        }
        const v = q.toLowerCase();
        setResults(
            postcodes.filter(entry =>
                entry.postcode.toLowerCase().includes(v) ||
                entry.locality.toLowerCase().includes(v)
            ).slice(0, 10)
        );
    }

    function handleInput(e) {
        const v = e.target.value;
        setQuery(v);
        onChange && onChange(v);
        filter(v);
        setShowResults(true);
    }

    function handleSelect(result) {
        setQuery(result.postcode);
        setShowResults(false);
        setResults([]);
        onChange && onChange(result.postcode);
        onSelect && onSelect({
            postcode: result.postcode,
            city: result.locality,
            province: result.state
        });
    }

    // Hide suggestions on outside click
    useEffect(() => {
        function handleClick(e) {
            if (
                resultsRef.current &&
                !resultsRef.current.contains(e.target) &&
                inputRef.current !== e.target
            ) {
                setShowResults(false);
            }
        }
        document.addEventListener('mousedown', handleClick);
        return () => document.removeEventListener('mousedown', handleClick);
    }, []);

    return (
        <div style={{ position: 'relative' }}>
            <Form.Control
                ref={inputRef}
                type="text"
                value={query}
                onChange={handleInput}
                disabled={disabled || loading}
                autoComplete="off"
                placeholder="Start typing suburb or postcode..."
                style={required ? { borderLeft: '3px solid #F14949' } : {}}
            />
            {loading && <Spinner animation="border" size="sm" style={{ position: 'absolute', right: 10, top: 8 }} />}
            {showResults && results.length > 0 && (
                <div ref={resultsRef} style={{
                    position: 'absolute',
                    zIndex: 1000,
                    background: 'white',
                    border: '1px solid #ccc',
                    width: '100%',
                    maxHeight: 200,
                    overflowY: 'auto',
                }}>
                    {results.map((result, i) => (
                        <div
                            key={i}
                            className="pcw-suggestion"
                            style={{ padding: 8, cursor: 'pointer' }}
                            onClick={() => handleSelect(result)}
                        >
                            {result.locality} {result.state} {result.postcode}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
